import { React, PT, withRouter } from '@gasbuddy/react';
import { Dimmer, Loader, Grid, Table, Segment, Header } from 'semantic-ui-react';
import { WithData } from '@gasbuddy/react/build/WithData';
import { Auth, Nav } from '../../components';
import { Role } from '../../roles';

class BaseCloOffer extends React.Component {
  state = {}

  render() {
    const { loading, data } = this.props;

    return (
      <Auth forRoles={[Role.Superuser, Role.GasBackCampaigns]}>
        <Nav>
          <Dimmer.Dimmable as={Segment} dimmed={loading}>
            <Dimmer active={loading}>
              <Loader />
            </Dimmer>
            <div>
              <Header>Offer Details</Header>
              <Grid>
                <Grid.Row stretched>
                  <Grid.Column width={10}>
                    <pre>{JSON.stringify(data?.offer, null, '\t')}</pre>
                  </Grid.Column>
                </Grid.Row>
              </Grid>
              <Header>Locations</Header>
              <Table striped>
                <Table.Header>
                  <Table.HeaderCell textAlign="center">Id</Table.HeaderCell>
                  <Table.HeaderCell textAlign="center">Offer Id</Table.HeaderCell>
                  <Table.HeaderCell>Street</Table.HeaderCell>
                  <Table.HeaderCell>City</Table.HeaderCell>
                  <Table.HeaderCell>State</Table.HeaderCell>
                  <Table.HeaderCell>Postal Code</Table.HeaderCell>
                </Table.Header>
                <Table.Body>
                  {data?.locations?.map(l => (
                    <Table.Row key={l.merchant_location_id}>
                      <Table.Cell>{l.merchant_location_id}</Table.Cell>
                      <Table.Cell>{l.encrypted_id}</Table.Cell>
                      <Table.Cell>
                        {l.street1}
                        {l.street2 ? <br /> : null}
                        {l.street2}
                      </Table.Cell>
                      <Table.Cell>{l.locality}</Table.Cell>
                      <Table.Cell>{l.region}</Table.Cell>
                      <Table.Cell>{l.postal_code}</Table.Cell>
                    </Table.Row>
                  ))}
                </Table.Body>
              </Table>
            </div>
          </Dimmer.Dimmable>
        </Nav>
      </Auth>
    );
  }
}

BaseCloOffer.propTypes = {
  data: PT.shape({
  }),
  //  fetch: PT.func,
  loading: PT.bool,
};

BaseCloOffer.defaultProps = {
  loading: true,
  data: null,
  // fetch() {},
};

export default withRouter(({ match }) => (
  <WithData url={`/loyalty/clo/offers/${match.params.offerId}`}>
    <BaseCloOffer
      offerId={Number(match.params.offerId)}
    />
  </WithData>
));
